import React from 'react';
import type { TaskNodeData } from './TaskflowParser';

interface Props {
  data: TaskNodeData | null;
  onClose: () => void;
}

export function TaskDetailDialog({ data, onClose }: Props): React.JSX.Element | null {
  if (!data) return null;
  return (
    <div className="taskflow-detail-backdrop" onClick={onClose}>
      <div className="taskflow-detail-dialog" onClick={e => e.stopPropagation()}>
        <div className="taskflow-detail-dialog__header">
          <h5>
            {data.title || data.name} <small className="text-muted">({data.xsiType})</small>
          </h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
        </div>
        <pre className="taskflow-detail-dialog__xml">{data.rawXml}</pre>
      </div>
    </div>
  );
}
